import React, { useState } from 'react';
import trainedModelFile from '../data/trained_model.pkl';

const DashboardUpload = () => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [downloadLink, setDownloadLink] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setUploadedFile(selectedFile);
    setDownloadLink(null); // Reset download link when a new file is uploaded
  };

  const handleFileUpload = () => {
    if (uploadedFile) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const content = event.target.result;

        // Create a Blob with the content and set content type
        const blob = new Blob([content], { type: 'application/octet-stream' });

        // Create a download link
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = trainedModelFile; // Use the original file name
        setDownloadLink(link);

        // Trigger the download
        link.click();

        // Clean up the download link
        setDownloadLink(null);
      };

      reader.readAsText(uploadedFile);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <label className="block text-gray-700 text-sm font-bold mb-4" htmlFor="fileInput">
          Choose a file:
        </label>
        <input
          type="file"
          id="fileInput"
          onChange={handleFileChange}
          className="appearance-none w-full py-2 px-3 border border-gray-300 rounded leading-tight focus:outline-none focus:shadow-outline mb-4"
        />

        <button
          type="button"
          onClick={handleFileUpload}
          className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Upload
        </button>

        {downloadLink && (
          <div className="mt-4">
            <p className="text-green-600 font-bold">Download link generated!</p>
            <a href={downloadLink.href} download={downloadLink.download} className="text-blue-500 hover:underline">
              Download File
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardUpload;
